export class IntegrationError extends Error {}
